module.exports = __webpack_public_path__ + "img/BLNK.694ff7ed.jpg";